import { Component, OnInit } from '@angular/core';
import {TableSelectionAbstract} from '../../../../../shared/component/table/table-selection.abstract';
import {GeneralService} from '../../../../../service/general-service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {NotificationService} from '../../../../../service/notification.service';
import {TranslateService} from '@ngx-translate/core';
import {AppConfigService} from '../../../../../../app-config.service';
import {WarehouseService} from '../../../../../service/warehouse.service';
import {FormBuilder} from '@angular/forms';
import {Constant} from '../../../../../shared/constants/constant.class';

@Component({
  selector: 'app-warehouse-eviction',
  templateUrl: './warehouse-eviction.component.html',
  styleUrls: ['./warehouse-eviction.component.scss']
})
export class WarehouseEvictionComponent extends TableSelectionAbstract implements OnInit {
  datas: any[] = [];
  data: any;
  loading: any;
  page: any;
  pageSize: any;
  defaultPage: any;
  checkDelete = true;
  checkUpdate = true;
  checkDetails = true;
  isVisibleAdd: boolean;
  enableEdit: boolean;
  searchText: any;
  checkAdd = true;
  chemicals: any[] = [];
  machines: any[] = [];
  filterData: any[];
  detailItems: any[];
  selectedData: any;
  scanBarcodeDefault: boolean;
  isEdit: boolean;
  viewOnly: boolean;
  loadingButton: boolean;
  selectedWarehouse: any;
  selectedWarehouseId: any;
  constructor(
    private generalService: GeneralService,
    private modalService: NzModalService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    private configService: AppConfigService,
    private warehouseService: WarehouseService,
    private fb: FormBuilder,
  ) {
    super('id');
    this.detailItems = [];
    this.enableEdit = true;
    this.scanBarcodeDefault = true;
    this.selectedData = {
      id: 0,
      code: '',
      description: '',
      receiveType: 1,
      recipient: '',
      warehouseEvictionDetails: [],
      scanBarcode: this.scanBarcodeDefault
    };
  }

  ngOnInit(): void {
    this.pageSize = this.configService.getConfig().pageSize;
    this.page = this.configService.getConfig().page;
    this.defaultPage = this.configService.getConfig().defaultPage;
    this.get();
    this.getCheckedIdList();
    this.getMachine();
    this.getSelectedWarehouse();
    this.getListData();
  }
  getSelectedWarehouse(){
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    this.warehouseService.getWarehouseById(this.selectedWarehouseId).subscribe(res => {
      this.selectedWarehouse = res;
    }, error => {

    });
  }
  getListData() {
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    this.loading = true;
    const filter = {
      page: 1,
      pageSize: 100,
      fromWareHouseId: this.selectedWarehouseId,
      userIdCreated: null
    };
    this.generalService.getWarehouseEvictionFilter(filter).subscribe(res => {
      if (res !== null) {
        this.datas = res.data;
        this.filterData = res.data;
        this.loading = false;
        super.setListOfAllData(this.datas);
      }
    }, error => {

    });
  }

  get() {
    this.translate.use(this.translate.currentLang).subscribe(data => {
      this.data = data;
    });
  }

  getChemicalsList() {
    this.generalService.getChemical().subscribe(res => {
      if (res !== null) {
        this.chemicals = res;
      }
    }, error => {

    });
  }
  getMachine() {
    this.generalService.getMachine().subscribe(res => {
      if (res !== null) {
        this.machines = res;
      }
    }, error => {

    });
  }

  showModalAdd() {
    this.viewOnly = false;
    this.isVisibleAdd = true;
    this.selectedData = {
      id: 0,
      code: '',
      description: '',
      warehouseEvictionDetails: [],
    };
  }

  addDetailInput() {
    const item = {
      id: 0,
      chemicalId: 0,
      amount: 0,
      price: 0,
      totalPrice: 0,
      lotNumber: '',
      expiredDate: new Date(),
    };
    this.selectedData.warehouseEvictionDetails.push(item);
  }

  doSearch() {
  }

  showModalUpdate(data) {
    this.isEdit = true;
    this.viewOnly = false;
    this.selectedData = data;
    this.selectedData.scanBarcode = this.scanBarcodeDefault;
    this.isVisibleAdd = true;
  }

  handleOk() {

    console.log(this.selectedData);
    if (!this.selectedData.description){
      this.notificationService.showNotification(Constant.ERROR, 'Chưa nhập mô tả phiếu');
      return;
    }
    if (!this.selectedData.warehouseEvictionDetails.length){
      this.notificationService.showNotification(Constant.ERROR, 'Chưa nhập chi tiết phiếu');
      return;
    }
    this.isVisibleAdd = false;
    this.loadingButton = true;
    this.selectedData.toWareHouseId = this.selectedWarehouseId;
    this.selectedData.details = this.selectedData.warehouseEvictionDetails;
    this.generalService.addWarehouseEviction(this.selectedData).subscribe(res => {
      this.loadingButton = false;
      console.log(res);
      if (res.ret && res.ret[0].code !== 0) {
        this.notificationService.showNotification(Constant.ERROR, res.ret[0].message);
      }
      else{
        this.isVisibleAdd = false;
        this.notificationService.showNotification(Constant.SUCCESS, 'Tạo phiếu thu hồi vỏ, hộp thành công');
        this.getListData();
      }
    }, error => {

    });
  }

  showConfirm(id): void {
    this.get();
    this.modalService.confirm({
      nzTitle: 'Confirm',
      nzContent: 'Bạn có muốn xóa hay không?',
      nzOkText: 'Đồng ý',
      nzCancelText: 'Bỏ qua',
      nzOnOk: () => this.deleteItem(id)
    });
  }

  deleteItem(id) {
    this.notificationService.showNotification(Constant.WARNING, 'Chức năng đang hoàn thiện');
  }

  deleteDetail($item) {
    this.selectedData.warehouseEvictionDetails = this.selectedData.warehouseEvictionDetails.filter(en => en.parcelDetailCode !== $item.parcelDetailCode);
  }

  showDetails(data) {
    this.selectedData = data;
    this.isVisibleAdd = true;
    this.viewOnly = true;
  }

  handleCancel() {
    this.isVisibleAdd = false;
  }

  getRowIndex = (index, pageIndex, pageSize) => index + 1 + pageSize * (pageIndex - 1);

  handleBarcode($event: any) {
    const existsItem = this.selectedData.warehouseEvictionDetails.find(en => en.parcelDetailCode === $event);
    if (existsItem){
      this.notificationService.showNotification(Constant.ERROR, 'Hộp, vỏ đã được nhập vào chi tiết phiếu');
      return;
    }
    this.generalService.getEvictionChemicalByBarCode($event).subscribe(res => {
      console.log(res);
      if (res.ret && res.ret[0].code !== 0) {
        this.notificationService.showNotification(Constant.ERROR, res.ret[0].message);
      }
      else{
        this.selectedData.parcelDetailCode = '';
        this.selectedData.warehouseEvictionDetails.push(res);
      }
    }, error => {

    });
  }
  exportPDF() {
    const phieuId = this.selectedData.id;
    const mainUrl = this.configService.getConfig().api.reportUrl + '/BridgeXLSDownload.aspx';
    const url = mainUrl + `?PhieuId=${phieuId}&report=PhieuXuatKho`;
    console.log(url);
    window.open(url, '_blank');
  }
}
